import React from "react"
import { Dialog, DialogContent, DialogFooter, DialogHeader } from './Dialog'
import styles from "./FormField.module.css"
import { Button as Button_ } from "reactstrap"
import { ShowableComponent } from "../hooks/use-dialog"
import { WidgetIdContext } from "../helpers/widget"
const Button = Button_ as any

export function HelpDialog(props: {
  component: ShowableComponent<{}, void>
  onClose: () => void
  widgetId?: string | null
}) {
  const Component = props.component
  return (
    <WidgetIdContext.Provider value={props.widgetId ?? null}>
      <Dialog frameClasses="w-[700px] min-w-[600px] min-h-[500px] h-[600px]" onClose={() => props.onClose()}>
        <DialogHeader title="Help" />
        <DialogContent>
          <div className={styles['help']}>
            <Component onClose={props.onClose} />
          </div>
        </DialogContent>
        <DialogFooter>
          <Button color="primary"
                  style={{ minWidth: "120px" }}
                  onClick={() => props.onClose()}>OK</Button>
        </DialogFooter>
      </Dialog>
    </WidgetIdContext.Provider>
  )
}